import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/Kpi";

/** Il MASTER decide quali notifiche push sono disponibili agli utenti e l'ora del riepilogo. */
export function PushEventiAdmin() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/push/admin/eventi").then((r) => setCfg(r.data)).catch(() => {}); }, []);

  const salva = async (next) => {
    setCfg(next);
    try {
      await api.put("/push/admin/eventi", { attivi: next.attivi, ora_riepilogo: next.ora_riepilogo });
      toast.success("Notifiche push aggiornate");
    } catch (e) { toast.error(apiError(e)); }
  };
  if (!cfg) return null;
  return (
    <Card className="p-6" data-testid="config-push">
      <div className="text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mb-1">Notifiche push disponibili</div>
      <div className="text-sm text-slate-600 mb-4">
        Gli utenti attivano le notifiche dal proprio Account e scelgono tra quelle abilitate qui.
        <span className="text-slate-400"> · {cfg.utenti_iscritti} utenti iscritti</span>
      </div>
      <div className="space-y-2">
        {cfg.eventi.map((e) => (
          <label key={e.chiave} className="flex items-start gap-3 text-sm cursor-pointer" data-testid={`push-admin-${e.chiave}`}>
            <input type="checkbox" checked={Boolean(cfg.attivi[e.chiave])} className="mt-1 accent-sky-600"
              onChange={() => salva({ ...cfg, attivi: { ...cfg.attivi, [e.chiave]: !cfg.attivi[e.chiave] } })} />
            <span>
              <span className="font-medium text-slate-800">{e.label}</span>
              <div className="text-xs text-slate-500">{e.descrizione}</div>
            </span>
          </label>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-3 text-sm">
        <span className="text-slate-600">Ora del riepilogo giornaliero</span>
        <input type="time" value={cfg.ora_riepilogo} data-testid="push-admin-ora"
          onChange={(e) => setCfg({ ...cfg, ora_riepilogo: e.target.value })}
          onBlur={() => salva(cfg)}
          className="border border-slate-300 rounded-md px-2 py-1 text-sm" />
      </div>
    </Card>
  );
}
